(function(angular){
	'use strict';
	
	var opportunityFundCtaObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			showSignUp: '=',
			cta: '@?'
		},
		controller: [
		'APP_BASE_PATH',
		'$cookies',
		'$rootScope',
		'addToWaitlistFactory',
		'localStorageFactory',
		'urlFactory',
		OpportunityFundFunction],
		controllerAs: 'opportunityFundCta'
	};
	
	angular
		.module('opportunityFundModule')
		.component('opportunityFundCta', opportunityFundCtaObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/opportunity-fund/opportunity-fund-cta.html';
	}
	
	function OpportunityFundFunction(
		APP_BASE_PATH,
		$cookies,
		$rootScope,
		addToWaitlistFactory,
		localStorageFactory,
		urlFactory
	){
		var opportunityFundCta = this;
		var lsKey = 'com.fundrise.opportunity-fund.signedUp';

		opportunityFundCta.openModal = function() {
			addToWaitlistFactory.ofundAddToWaitlist(opportunityFundCta.email).then(function() {
				$rootScope.ModalFactory.openOpportunityFundSignup()
					.then(function (modal) {
						modal.close.then(function (result) {
							if (result && result.success) {
								result.fields.email = opportunityFundCta.email;
								urlFactory.postPromise('/opportunity-fund/waitlist/join', result.fields)
									.then(function () {
										opportunityFundCta.showSignUp = false;
										localStorageFactory.setItem(lsKey, true);

										var url = '/offerings/opportunity-fund/view';

										if(angular.isDefined(opportunityFundCta.cta)) {
											url = urlFactory.serializeParamsAndCreateUrl(url, {
												'cta': opportunityFundCta.cta
											});
										}

										urlFactory.redirect(url);
									});
							} else {
								opportunityFundCta.formSubmitted = false;
							}
						});
					});
			});
		};

		opportunityFundCta.$onInit = function() {
			opportunityFundCta.showSignUp = !$cookies.get('com.fundrise.opportunity_fund.eligibility');
			opportunityFundCta.offeringLink = APP_BASE_PATH + '/offerings/opportunity-fund/view';
		};
	}
})(window.angular);